import { useEffect, useState } from "react";
import { GoogleFormComponent, GoogleFormStatus, useGoogleForm } from "@components/organisms/GoogleForm";
import { DefaultTemplate } from "@components/templates/default";
import { useTranslation } from "@refinedev/core";

export function WellnessDiagnosis() {
    const { translate } = useTranslation();

    enum Status {
        GoogleForm,
        SaysGoodbye,
    };

    const [status, setStatus] = useState(Status.GoogleForm);
    const { loading, status: formStatus } = useGoogleForm();

    useEffect(() => {
        if (formStatus === GoogleFormStatus.end) {
            setStatus(Status.SaysGoodbye);
        }
    }, [formStatus]);

    const GoodByeAnouncement = () => (
        <div className="prose p-8 text-center max-w-2xl">
            <h2 className="text-2xl font-bold mb-4">{translate("page.wellness-diagnosis.page.title")}</h2>
            <p className="text-lg">
                {translate("page.wellness-diagnosis.page.goodbye")}
            </p>
        </div>
    );

    return (
        <DefaultTemplate>
            <div className="flex-1 flex items-center justify-center p-4">
                <div className="h-full w-full max-w-5xl flex flex-col items-center">
                    {status === Status.GoogleForm && (
                        <h1 className="text-2xl font-bold mb-6 text-center">
                            {translate("page.wellness-diagnosis.page.title")}
                        </h1>
                    )}
                    <div className="w-full h-[80vh] flex justify-center">
                        {{
                            [Status.GoogleForm]: (
                                <GoogleFormComponent
                                    loading={loading}
                                    googleFormID="1FAIpQLSdrW_zD_A-XNq9_7MvE-XQ_M-L-zD_A-XNq9_7MvE-XQ_M-L" // Placeholder ID
                                    className="w-full h-full rounded-2xl overflow-hidden shadow-lg border border-base-200"
                                    status={formStatus}
                                />
                            ),
                            [Status.SaysGoodbye]: <GoodByeAnouncement />,
                        }[status]}
                    </div>
                </div>
            </div>
        </DefaultTemplate>
    );
}

export default WellnessDiagnosis;
